// extracted by mini-css-extract-plugin
export var createdDate = "_l8-1";
export var divider = "_l8-2";
export var headerDivider = "_l8-3";
export var messagesCard = "_l8-0";
export var messagesContainer = "_l8-7";
export var messagesContainerWrapper = "_l8-4";
export var pointerCapturingButtonBoxes = "_l8-a";
export var showLeftPanelButton = "_l8-9";
export var showMoreButton = "_l8-c";
export var showMoreButtonContainer = "_l8-b";
export var summaryTitle = "_l8-6";
export var systemMessageCardWrapper = "_l8-d";
export var topButtons = "_l8-8";
export var withPadding = "_l8-5";